import React from "react";

export default function PageHeader({
  heading,
  description,
  cta,
  marginTop = "-mt-[28px]",
  marginBottom = "",
  marginLeft = "-ml-[32px]",
  marginRight = "-mr-[32px]",
  borderMarginTop,
  borderMarginBottom = "mb-[24px]",
  className = "",
  goBack = false,
  children,
}) {
  return (
    <div className={`bg-background ${marginTop} ${marginBottom} ${marginLeft} ${marginRight} ${className}`}>
      {goBack ? (
        <div className="p-6">{children ? children : ""}</div>
      ) : (
        <>
          <div className="sm:flex sm:items-center w-full justify-between  p-6">
            <div className="sm:flex-auto">
              <h2 className="text-lg font-semibold leading-7 text-text-900">{heading}</h2>
              <p className="text-text-600 mt-1">{description}</p>
            </div>
            {cta && cta}
          </div>
        </>
      )}
      <div className={`border-b border-border ${borderMarginTop} ${borderMarginBottom}`}></div>
    </div>
  );
}
